import type { VisitConsentConfirmPayload } from "../../hooks/Remote/Schedule/visit-consent-confirm.api";

export type VisitConsentConfirmDocumentRow = { id: string };

/**
 * Builds the public consent-confirm POST body from UI state.
 * Returns `null` until every document is accepted and a signature + signing instant exist.
 */
export function buildVisitConsentConfirmPayload(input: {
  token: string | undefined;
  documentList: VisitConsentConfirmDocumentRow[];
  documentConsents: Record<string, boolean>;
  signaturePngBase64: string | null;
  signingMoment: Date | null;
}): VisitConsentConfirmPayload | null {
  const { token, documentList, documentConsents, signaturePngBase64, signingMoment } = input;

  if (!token || documentList.length === 0) {
    return null;
  }

  if (!signingMoment || !signaturePngBase64) {
    return null;
  }

  const allDocumentsAccepted = documentList.every(d => documentConsents[d.id] === true);
  if (!allDocumentsAccepted) {
    return null;
  }

  return {
    token,
    consents: documentList.map(d => ({
      documentId: d.id,
      consented: documentConsents[d.id] ?? false
    })),
    signaturePngBase64,
    signedAt: signingMoment.toISOString()
  };
}
